import { Entity } from '@backstage/catalog-model';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import { ANNOTATION_CODE_OWNERSHIP } from '@appfolio/backstage-plugin-code-ownership-common';

export const isCodeOwnershipEnabled = (entity: Entity) =>
  entityUtil(entity).isAnnotatedWith(ANNOTATION_CODE_OWNERSHIP, 'enabled');
